<div class="tool-container {{ side }}-cell-tool" *ngIf="cellButton.showButton">

  <div *ngIf="this.side != 'left'" class="flex flex-row gap-3">
    <p-button
      icon="fa fa-minus"
      [severity]="'danger'"
      [rounded]="true"

      [raised]="true"
      (click)="reduce()"
      styleClass="n-button-icon-xs"
      *ngIf="showDecrease()"
    >
    </p-button>
    <p-button
      icon="fa fa-plus"
      [severity]="'success'"
      [rounded]="true"
      [raised]="true"
      
      styleClass="n-button-icon-xs"
      (click)="expand()"
      *ngIf="isVisible()"
    >
    </p-button>
  </div>

  <div *ngIf="this.side == 'left'" class="flex flex-row gap-3">
    <p-button
      icon="fa fa-plus"
      [severity]="'success'"
      [rounded]="true"
      [raised]="true"
      
      styleClass="n-button-icon-xs"
      (click)="expand()"
      *ngIf="isVisible()"
    >
    </p-button>
    <p-button
      icon="fa fa-minus"
      [severity]="'danger'"
      [rounded]="true"

      [raised]="true"
      styleClass="n-button-icon-xs"
      (click)="reduce()"
      *ngIf="showDecrease()"
    >
    </p-button>
  </div>
</div>
